import { render, staticRenderFns } from "./DashboardGroup.vue?vue&type=template&id=9a60162a&scoped=true&"
import script from "./DashboardGroup.vue?vue&type=script&lang=js&"
export * from "./DashboardGroup.vue?vue&type=script&lang=js&"
import style0 from "./DashboardGroup.vue?vue&type=style&index=0&id=9a60162a&lang=scss&scoped=true&"
import style1 from "./DashboardGroup.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a60162a",
  null
  
)

export default component.exports